var Backbone = require("../../libs/backbone/backbone");
var GenericModel = require("./generic.model.ts");

var QueuesModel = GenericModel.extend(
{
    urlRoot : '/rest/api/queues',
    id : null,
    name : "",
    ticket_number_min : "",
    ticket_number_max : "",
    active_times_open : "",
    active_times_close : "",
    agents : "",
    queue_macro: "",
    type: "",
    ticketIssueManually: false,
    needsPreparation: false,
    searchable: "",
    min_service_time: 300,
    notification_time_after_service: 180,
    servicingLetter: ""
});

module.exports = QueuesModel;